import * as React from 'react';

import { APP_EMAIL } from '../../config';
import { localeData } from '../../locales/data';

import './ErrorBoundary.scss';
import { FormattedMessageHelper } from '../../shared/helpers/internationalization';

interface ErrorMessageProps {
  isNotFullScreen: boolean;
  userId: string;
}

export const ErrorMessage = ({ isNotFullScreen, userId }: ErrorMessageProps) => {
  const mailRef = `mailto:${APP_EMAIL}?subject=An Application Error Has Occurred For ${userId || 'Not Signed In User'}`;

  return (
    <div className={`error-boundary error-boundary${isNotFullScreen ? '--not-full' : ''}`}>
      <h1 className="error-boundary__header">
        <FormattedMessageHelper tagName="span" id="error.boundary.1" defaultMessage={localeData.en['error.boundary.1']} />
      </h1>
      <div className="error-boundary__content">
        <p className="error-boundary__element">
          <FormattedMessageHelper tagName="span" id="error.boundary.2" defaultMessage={localeData.en['error.boundary.2']} />
          &nbsp;
          <a className="error-boundary__element-link" href="/">
            <FormattedMessageHelper tagName="span" id="error.boundary.4" defaultMessage={localeData.en['error.boundary.4']} />
          </a>
        </p>
        <p className="error-boundary__element">
          <FormattedMessageHelper tagName="span" id="error.boundary.5" defaultMessage={localeData.en['error.boundary.5']} />
          <a className="error-boundary__element-link" href={mailRef}>
            <FormattedMessageHelper tagName="span" id="error.boundary.6" defaultMessage={localeData.en['error.boundary.6']} />
          </a>
          <FormattedMessageHelper tagName="span" id="error.boundary.7" defaultMessage={localeData.en['error.boundary.7']} />
        </p>
      </div>
    </div>
  );
};
